module.exports = __webpack_public_path__ + "img/location-disabled-white.9805f2b4.svg";